/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { defineCustomElements } from '@garpix/garpix-web-components/loader';
defineCustomElements();
export const GxBadge = /*@__PURE__*/ createReactComponent('gx-badge');
export const GxButton = /*@__PURE__*/ createReactComponent('gx-button');
export const GxButtonGroup = /*@__PURE__*/ createReactComponent('gx-button-group');
export const GxCheckbox = /*@__PURE__*/ createReactComponent('gx-checkbox');
export const GxCol = /*@__PURE__*/ createReactComponent('gx-col');
export const GxColorPicker = /*@__PURE__*/ createReactComponent('gx-color-picker');
export const GxComplete = /*@__PURE__*/ createReactComponent('gx-complete');
export const GxDropdown = /*@__PURE__*/ createReactComponent('gx-dropdown');
export const GxForm = /*@__PURE__*/ createReactComponent('gx-form');
export const GxGrid = /*@__PURE__*/ createReactComponent('gx-grid');
export const GxHamburger = /*@__PURE__*/ createReactComponent('gx-hamburger');
export const GxIcon = /*@__PURE__*/ createReactComponent('gx-icon');
export const GxInput = /*@__PURE__*/ createReactComponent('gx-input');
export const GxLink = /*@__PURE__*/ createReactComponent('gx-link');
export const GxMenu = /*@__PURE__*/ createReactComponent('gx-menu');
export const GxMenuDivider = /*@__PURE__*/ createReactComponent('gx-menu-divider');
export const GxMenuItem = /*@__PURE__*/ createReactComponent('gx-menu-item');
export const GxModal = /*@__PURE__*/ createReactComponent('gx-modal');
export const GxNumberFormat = /*@__PURE__*/ createReactComponent('gx-number-format');
export const GxPhoneInput = /*@__PURE__*/ createReactComponent('gx-phone-input');
export const GxProgressBar = /*@__PURE__*/ createReactComponent('gx-progress-bar');
export const GxProgressRing = /*@__PURE__*/ createReactComponent('gx-progress-ring');
export const GxRadio = /*@__PURE__*/ createReactComponent('gx-radio');
export const GxRange = /*@__PURE__*/ createReactComponent('gx-range');
export const GxRating = /*@__PURE__*/ createReactComponent('gx-rating');
export const GxRow = /*@__PURE__*/ createReactComponent('gx-row');
export const GxSelect = /*@__PURE__*/ createReactComponent('gx-select');
export const GxSpinner = /*@__PURE__*/ createReactComponent('gx-spinner');
export const GxSwitch = /*@__PURE__*/ createReactComponent('gx-switch');
export const GxTab = /*@__PURE__*/ createReactComponent('gx-tab');
export const GxTabGroup = /*@__PURE__*/ createReactComponent('gx-tab-group');
export const GxTabPanel = /*@__PURE__*/ createReactComponent('gx-tab-panel');
export const GxTag = /*@__PURE__*/ createReactComponent('gx-tag');
export const GxTextarea = /*@__PURE__*/ createReactComponent('gx-textarea');
export const GxTooltip = /*@__PURE__*/ createReactComponent('gx-tooltip');
//# sourceMappingURL=components.js.map